import type { CreateAiAgentPayload } from "@/models/aiAgents";

export const AI_AGENTS_SCHEMA_VERSION = "1.0.0";
export const AI_AGENTS_MESSAGE_SCHEMA_VERSION = "1.0.0";

export const NEW_AGENT: CreateAiAgentPayload = {
  name: "",
  description: null,
  type: "webhook",
  content: {
    version: AI_AGENTS_SCHEMA_VERSION,
    agent: {
      type: "webhook",
      webhook_url: "",
    },
  },
};

export const AI_AGENTS_REGEX = {
  AGENT_TILE: /<span[^>]*data-agent="[^"]*"[^>]*>.*?<\/span>/,
  DEAL: /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/,
};

export const NON_BREAKING_SPACE = "\u00A0";
